var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-container",
    { staticClass: "pa-3", attrs: { fluid: "" } },
    [
      _c(
        "v-row",
        { staticClass: "mt-1" },
        [
          _c(
            "v-col",
            { staticClass: "pa-0 mt-n3", attrs: { cols: "12" } },
            [
              _c(
                "v-toolbar",
                {
                  attrs: { width: "100%", flat: "" },
                  scopedSlots: _vm._u([
                    {
                      key: "extension",
                      fn: function () {
                        return [
                          _c(
                            "v-tabs",
                            { attrs: { xs: "" } },
                            _vm._l(_vm.filteredWorkflows, function (workflow) {
                              return _c(
                                "v-tab",
                                {
                                  key: workflow.id,
                                  on: {
                                    click: function ($event) {
                                      return _vm.changeFilter(workflow.id)
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(workflow.displayName))]
                              )
                            }),
                            1
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _c(
                    "v-toolbar-title",
                    [
                      _c("div", { staticClass: "float-left mr-4" }, [
                        _vm._v("Workflows"),
                      ]),
                      _c("v-spacer"),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: _vm.selectedDefinition.length > 0 ? "8" : "12" } },
            [
              _c("v-data-table", {
                attrs: {
                  headers: _vm.tableHeaders,
                  items: _vm.filteredDefinitions,
                  "single-select": true,
                  "items-per-page": 100,
                  "hide-default-footer": "",
                },
                on: { "click:row": _vm.rowClick },
                scopedSlots: _vm._u(
                  [
                    {
                      key: `item.pipelinePhaseTypeId`,
                      fn: function ({ item }) {
                        return [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.PipelinePhaseType[item.pipelinePhaseTypeId]
                              ) +
                              " "
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  true
                ),
                model: {
                  value: _vm.selectedDefinition,
                  callback: function ($$v) {
                    _vm.selectedDefinition = $$v
                  },
                  expression: "selectedDefinition",
                },
              }),
            ],
            1
          ),
          _vm.selectedDefinition.length > 0
            ? _c("workflows-sidebar", {
                attrs: {
                  "local-selected-definition": _vm.localSelectedDefinition,
                  "pipeline-phase-types": _vm.pipelinePhaseTypes,
                  "activity-definition-types": _vm.activityDefinitionTypes,
                  editor: _vm.editor,
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }